import ActualPackStatus from '~/Api/Analytics/VirtualBrand/ActualPackStatus';
import DataSource from '~/Api/DataSource/DataSource';
import ProductPrice from '~/Api/Product/ProductPrice';

export default class PriceTime {
	days: number;

	since: Date;

	dataSource: DataSource | null;

	price: ProductPrice | null;

	status: ActualPackStatus;

	constructor(
		days: number,
		since: Date,
		dataSource: DataSource | null,
		price: ProductPrice | null,
		status: ActualPackStatus
	) {
		this.days = days;
		this.since = since;
		this.dataSource = dataSource;
		this.price = price;
		this.status = status;
	}
}
